var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoLocationsLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.8135 76.1273C46.3565 77.3098 42.293 77.231 39.647 75.9697L24.9996 68.875C22.4481 67.6137 22.2591 65.643 24.7161 64.4606C27.1731 63.2781 31.2366 63.3569 33.8826 64.6182L48.53 71.7129C51.176 72.9742 51.2705 74.9449 48.8135 76.1273Z",
    fill: "url(#paint0_linear_1402_363362)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9101 39.3458C63.9101 44.0758 62.5801 47.9058 60.1001 50.2458C60.1001 50.2458 59.5801 50.7358 59.5101 50.7958L50.2401 58.0658L45.0701 62.1158L44.9901 62.1558L34.9701 67.9658L46.8901 58.6158L49.4201 56.6358C49.5001 56.5758 50.0101 56.0858 50.0101 56.0858C50.6501 55.4758 51.2101 54.7758 51.7001 53.9758C53.0901 51.6958 53.8201 48.6858 53.8201 45.1758C53.8201 42.0458 53.2401 38.7358 52.2101 35.4458C50.3101 29.3758 46.8401 23.3758 42.5401 18.6858C41.4301 17.4658 40.2501 16.3458 39.0401 15.3258C37.7101 14.2158 36.3301 13.2358 34.9101 12.4158C33.1001 11.3758 31.3501 10.6658 29.7001 10.2558C26.7101 9.51584 24.0301 9.78584 21.8401 10.9358L31.5101 5.33584L31.7401 5.20584C31.7401 5.20584 31.8101 5.16584 31.8401 5.14584C35.2401 3.29584 39.8801 3.62584 45.0001 6.57584C46.4101 7.39584 47.7901 8.37584 49.1201 9.48584C57.5801 16.5458 63.9001 28.9058 63.9101 39.3358V39.3458Z",
    fill: "url(#paint1_linear_1402_363362)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9 68.006L34.94 67.986L34.9 68.006Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.21 35.4559C50.31 29.3859 46.84 23.3859 42.54 18.6959C41.43 17.4759 40.25 16.3559 39.04 15.3359C37.71 14.2259 36.33 13.2459 34.91 12.4259C33.1 11.3859 31.35 10.6759 29.7 10.2659C26.71 9.52592 24.03 9.79592 21.84 10.9459L21.23 11.3059C17.99 13.3559 16.01 17.5059 16 23.3459C16 24.9559 16.15 26.6459 16.46 28.3759C17.04 31.7159 18.18 35.2259 19.81 38.6459C19.81 38.6459 20.33 39.7259 20.41 39.8859L29.22 56.9759L34.91 68.0059L34.95 67.9859L46.87 58.6259L49.4 56.6459C49.48 56.5859 49.99 56.0959 49.99 56.0959C50.63 55.4859 51.19 54.7859 51.68 53.9859C53.07 51.7059 53.8 48.6959 53.8 45.1859C53.8 42.0559 53.22 38.7459 52.19 35.4559H52.21ZM38.85 43.0459C37.74 43.3059 36.38 43.0459 34.91 42.2059C31.11 40.0159 28.03 34.6759 28.03 30.2959C28.03 27.8059 29.02 26.1559 30.57 25.5959C31.75 25.1659 33.26 25.3759 34.9 26.3259C38.7 28.5159 41.78 33.8559 41.78 38.2359C41.78 40.9259 40.62 42.6359 38.85 43.0459Z",
    fill: "#D7D7D7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.78 38.236C41.78 40.926 40.62 42.636 38.85 43.046C37.74 43.306 36.38 43.046 34.91 42.206C31.11 40.016 28.03 34.676 28.03 30.296C28.03 27.806 29.02 26.156 30.57 25.596C31.75 25.166 33.26 25.376 34.9 26.326C38.7 28.516 41.78 33.856 41.78 38.236Z",
    fill: "url(#paint2_linear_1402_363362)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1402_363362",
    x1: 36.7441,
    y1: 78.6274,
    x2: 43.3195,
    y2: 65.0715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525252",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1402_363362",
    x1: 22,
    y1: 10,
    x2: 54,
    y2: 57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.211673,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425569,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550544,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.709325,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8",
    stopOpacity: 0.68
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1402_363362",
    x1: 30.04,
    y1: 25.846,
    x2: 39.77,
    y2: 42.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoLocationsLarge);
export default __webpack_public_path__ + "static/media/no_locations_large.3b546fe9ea55009b6ec2a33c4b2ba9d1.svg";
export { ForwardRef as ReactComponent };